'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REQUEST_ASYNC = exports.REQUEST_ASYNC = '@@query/REQUEST_ASYNC';
var REQUEST_START = exports.REQUEST_START = '@@query/REQUEST_START';
var REQUEST_SUCCESS = exports.REQUEST_SUCCESS = '@@query/REQUEST_SUCCESS';
var REQUEST_FAILURE = exports.REQUEST_FAILURE = '@@query/REQUEST_FAILURE';

var CANCEL_QUERY = exports.CANCEL_QUERY = '@@query/CANCEL_QUERY';

var MUTATE_ASYNC = exports.MUTATE_ASYNC = '@@query/MUTATE_ASYNC';
var MUTATE_START = exports.MUTATE_START = '@@query/MUTATE_START';
var MUTATE_SUCCESS = exports.MUTATE_SUCCESS = '@@query/MUTATE_SUCCESS';
var MUTATE_FAILURE = exports.MUTATE_FAILURE = '@@query/MUTATE_FAILURE';

var RESET = exports.RESET = '@@query/RESET';
var UPDATE_ENTITIES = exports.UPDATE_ENTITIES = '@@query/UPDATE_ENTITIES';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-query/dist/es/constants/action-types.js
// module id = 70
// module chunks = 27